import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { PUT } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  UPDATE_CLIENT,
  UPDATE_CLIENT_FAILURE,
  UPDATE_CLIENT_SUCCESS,
  UpdateClientActionType
} from 'src/redux/clientsReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* UpdateClientFlow(action: UpdateClientActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers/clients/${action.payload.id}`
    yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: PUT,
      params: {
        client: {
          name: action.payload.name,
          email: action.payload.email
        }
      }
    })
    yield put(UPDATE_CLIENT_SUCCESS(action.payload))
  } catch (error) {
    yield put(UPDATE_CLIENT_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* UpdateClientSaga(): Generator<any, void, any> {
  yield takeLatest(UPDATE_CLIENT, UpdateClientFlow)
}
